import { Button } from "@mui/material";
import { Formik } from "formik";
import FormikTextField from "../../../commons/formik/FormikTextField";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../styled/Prevencion";
import { observacionesValidation } from "../validation/formValidation";

const ObservacionesForm = ({ handleSubmit, handleCancelForm, formModel }) => {

  return (
    <>
      {formModel ? (
        <Formik
          initialValues={formModel}
          onSubmit={handleSubmit}
          validationSchema={observacionesValidation}
        >
          <StyledResolucion.Form style={{ padding: 10 }}>
            <FormikTextField
              multiline
              fullWidth
              maxRows={6}
              minRows={6}
              name="observacionesGenerales"
              id="observacionesGenerales"
              label="Observaciones Generales *"
              variant="filled"
            />
            <FormikTextField
              multiline
              fullWidth
              maxRows={6}
              minRows={6}
              name="descripcionActividadEstablecimiento"
              id="descripcionActividadEstablecimiento"
              label="Descripción de la Actividad de Establecimiento *"
              variant="filled"
            />
            <StyledResolucion.ButtonContainer>
              <StyledResolucion.CancelButton
                variant="contained"
                onClick={handleCancelForm}
              >
                CANCELAR FORMULARIO
              </StyledResolucion.CancelButton>
              <Button color="primary" type="submit" variant="contained">
                SIGUIENTE
              </Button>
            </StyledResolucion.ButtonContainer>
          </StyledResolucion.Form>
        </Formik>
      ) : (
        <>
          <CircularLoading />
        </>
      )}
    </>
  );
};

export default ObservacionesForm;
